import React from 'react'
import imagesLoaded from 'imagesloaded';

const preloaderInit = (preloaderEl) => {
    let bodyElement = document.querySelector('body')
    if (bodyElement) {
        imagesLoaded(bodyElement, () => {
            !preloaderEl ? void 0 : preloaderEl.classList.add('loaded')
            setTimeout(() => {
                !preloaderEl ? void 0 : preloaderEl.remove()
            }, 800)
        })
    }
}

const Preloader = () => {
    const preloaderRef = React.useRef(null)

    React.useEffect(() => {
        if (preloaderInit.current !== null) {
            preloaderInit(preloaderRef.current)
        }
    }, [])

    return (
        <div className="preloader" ref={preloaderRef} id="preloader">
            <div className="loader">
                <div className="line-scale-pulse-out-rapid">
                    <div> </div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div> </div>
                </div>
            </div>
        </div>
    )
}

export default Preloader